"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));
var _reactWindow = require("react-window");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      margin: "auto"
    },
    paper: {
      width: "100%",
      height: 500,
      overflow: "auto"
    },
    button: {
      margin: theme.spacing(0.5, 0.5)
    },
    rootPaperLeft: {
      paddingLeft: "0px !important"
    },
    rootPaperRight: {
      paddingRight: "8px !important"
    },
    label: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    listItemText: {
      "& span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    },
    gridEmpty: {
      width: "100%",
      marginTop: theme.spacing(1),
      overflow: "hidden"
    }
  };
});
function not(a, b) {
  return a.filter(function (value) {
    return !b.find(function (vb) {
      return vb.id === value.id;
    });
  });
}
function applyFilterLeft(allItens, selectedItens) {
  return not(allItens, selectedItens);
}
var Row = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var data = _ref.data,
    index = _ref.index,
    style = _ref.style;
  var classes = useStyles();
  var items = data.items,
    getItemIdentifier = data.getItemIdentifier,
    getItemText = data.getItemText,
    handleToggle = data.handleToggle;
  var item = items[index];
  var labelId = "transfer-list-item-".concat(getItemIdentifier(item), "-label");
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    key: index,
    button: true,
    onClick: function onClick() {
      return handleToggle(index);
    },
    style: style,
    disableRipple: true,
    disabled: item.disabled
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    size: "small",
    checked: !!item.checked,
    tabIndex: -1,
    disableRipple: true,
    inputProps: {
      "aria-labelledby": labelId
    }
  })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    size: "small",
    id: labelId,
    primary: getItemText(item),
    className: classes.listItemText
  }));
}, _reactWindow.areEqual);
var SttDoubleList = function SttDoubleList(_ref2) {
  var allItens = _ref2.allItens,
    selectedItens = _ref2.selectedItens,
    onChange = _ref2.onChange,
    getItemText = _ref2.getItemText,
    getItemIdentifier = _ref2.getItemIdentifier,
    labelLeft = _ref2.labelLeft,
    labelRight = _ref2.labelRight,
    reset = _ref2.reset,
    callbackReset = _ref2.callbackReset,
    field = _ref2.field;
  var classes = useStyles();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    checkedLeft = _useState2[0],
    setCheckedLeft = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    checkedRight = _useState4[0],
    setCheckedRight = _useState4[1];
  var _useState5 = (0, _react.useState)(function () {
      return applyFilterLeft(allItens, selectedItens);
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    left = _useState6[0],
    setLeft = _useState6[1];
  var _useState7 = (0, _react.useState)(selectedItens),
    _useState8 = _slicedToArray(_useState7, 2),
    right = _useState8[0],
    setRight = _useState8[1];
  var ordenarLista = (0, _react.useCallback)(function (a, b) {
    var normalizarTexto = function normalizarTexto(texto) {
      return texto.toUpperCase().replace(/[ÀÁÂÃÄÅ]/g, "A").replace(/[ÈÉÊË]/g, "E").replace(/[Ç]/g, "C");
    };
    var textoA = normalizarTexto(getItemText(a));
    var textoB = normalizarTexto(getItemText(b));
    return textoA.localeCompare(textoB);
  }, [getItemText]);
  var limparSelecao = (0, _react.useCallback)(function (itens) {
    return itens.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        checked: false
      });
    });
  }, []);
  var moverItensEntreListas = (0, _react.useCallback)(function (listaEsquerda, listaDireita) {
    var deveOrdenarDireita = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var esquerda = limparSelecao(listaEsquerda);
    var direita = limparSelecao(listaDireita);
    setLeft(esquerda);
    setRight(deveOrdenarDireita ? direita.sort(ordenarLista) : direita);
    setCheckedLeft(0);
    setCheckedRight(0);
    onChange === null || onChange === void 0 ? void 0 : onChange(direita);
    field.handleBlur();
  }, [ordenarLista, onChange, field, limparSelecao]);
  var moverTodosParaDireita = (0, _react.useCallback)(function () {
    var itensDesabilitados = left.filter(function (item) {
      return item.disabled;
    });
    var itensHabilitados = left.filter(function (item) {
      return !item.disabled;
    });
    moverItensEntreListas(itensDesabilitados, [].concat(_toConsumableArray(right), _toConsumableArray(itensHabilitados)));
  }, [left, right, moverItensEntreListas]);
  var moverSelecionadosParaDireita = (0, _react.useCallback)(function () {
    var itensSelecionados = left.filter(function (item) {
      return item.checked;
    });
    var itensNaoSelecionados = left.filter(function (item) {
      return !item.checked;
    });
    moverItensEntreListas(itensNaoSelecionados, [].concat(_toConsumableArray(right), _toConsumableArray(itensSelecionados)));
  }, [left, right, moverItensEntreListas]);
  var moverSelecionadosParaEsquerda = (0, _react.useCallback)(function () {
    var itensSelecionados = right.filter(function (item) {
      return item.checked;
    });
    var itensNaoSelecionados = right.filter(function (item) {
      return !item.checked;
    });
    var novaListaEsquerda = [].concat(_toConsumableArray(left), _toConsumableArray(itensSelecionados)).sort(ordenarLista);
    moverItensEntreListas(novaListaEsquerda, itensNaoSelecionados, false);
  }, [left, right, ordenarLista, moverItensEntreListas]);
  var moverTodosParaEsquerda = (0, _react.useCallback)(function () {
    var itensDesabilitados = right.filter(function (item) {
      return item.disabled;
    });
    var itensHabilitados = right.filter(function (item) {
      return !item.disabled;
    });
    var novaListaEsquerda = [].concat(_toConsumableArray(left), _toConsumableArray(itensHabilitados)).sort(ordenarLista);
    moverItensEntreListas(novaListaEsquerda, itensDesabilitados, false);
  }, [left, right, ordenarLista, moverItensEntreListas]);
  (0, _react.useEffect)(function () {
    setLeft(applyFilterLeft(allItens, selectedItens));
    setRight(selectedItens);
  }, [allItens, selectedItens]);
  (0, _react.useEffect)(function () {
    if (reset) {
      setCheckedRight(0);
      setCheckedLeft(0);
      setRight(limparSelecao(selectedItens));
      setLeft(limparSelecao(applyFilterLeft(allItens, selectedItens)));
      field.handleBlur();
      callbackReset === null || callbackReset === void 0 ? void 0 : callbackReset();
    }
  }, [reset, selectedItens, allItens, field, callbackReset, limparSelecao]);
  var criarAlternadorDeSelecao = (0, _react.useCallback)(function (itens, atualizarItens, atualizarContador) {
    return function (indice) {
      var novosItens = _toConsumableArray(itens);
      var estaSelecionado = !novosItens[indice].checked;
      novosItens[indice] = _objectSpread(_objectSpread({}, novosItens[indice]), {}, {
        checked: estaSelecionado
      });
      atualizarItens(novosItens);
      atualizarContador(function (contador) {
        return estaSelecionado ? contador + 1 : contador - 1;
      });
    };
  }, []);
  var alternarSelecaoEsquerda = (0, _react.useCallback)(criarAlternadorDeSelecao(left, setLeft, setCheckedLeft), [left, criarAlternadorDeSelecao]);
  var alternarSelecaoDireita = (0, _react.useCallback)(criarAlternadorDeSelecao(right, setRight, setCheckedRight), [right, criarAlternadorDeSelecao]);
  var criarDadosDoItem = (0, _react.useCallback)(function (itens, alternarSelecao) {
    return {
      items: itens,
      getItemIdentifier: getItemIdentifier,
      getItemText: getItemText,
      classes: classes,
      handleToggle: alternarSelecao
    };
  }, [getItemIdentifier, getItemText, classes]);
  var dadosItensEsquerda = (0, _react.useMemo)(function () {
    return criarDadosDoItem(left, alternarSelecaoEsquerda);
  }, [left, alternarSelecaoEsquerda, criarDadosDoItem]);
  var dadosItensDireita = (0, _react.useMemo)(function () {
    return criarDadosDoItem(right, alternarSelecaoDireita);
  }, [right, alternarSelecaoDireita, criarDadosDoItem]);
  var renderizarLista = (0, _react.useCallback)(function (dadosItens, mensagemListaVazia) {
    return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
      className: classes.paper
    }, dadosItens.items.length > 0 ? /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
      height: 500,
      itemCount: dadosItens.items.length,
      itemData: dadosItens,
      itemSize: 35,
      width: "100%"
    }, Row) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      spacing: 1,
      alignItems: "center",
      justifyContent: "center",
      className: classes.gridEmpty
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      component: "legend",
      className: classes.label
    }, mensagemListaVazia)));
  }, [classes]);
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 1,
    alignItems: "center",
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: true,
    className: classes.rootPaperLeft
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend",
    className: classes.label
  }, labelLeft), renderizarLista(dadosItensEsquerda, "Nenhum item disponível")), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: 1
  }, /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverTodosParaDireita,
    disabled: left.length === 0,
    "aria-label": "Mover tudo para \xE0 direita"
  }, "\u226B"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverSelecionadosParaDireita,
    disabled: checkedLeft === 0,
    "aria-label": "Mover selecionados para \xE0 direita"
  }, ">"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverSelecionadosParaEsquerda,
    disabled: checkedRight === 0,
    "aria-label": "Mover selecionados para \xE0 esquerda"
  }, "<"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverTodosParaEsquerda,
    disabled: right.length === 0,
    "aria-label": "Mover tudo para \xE0 esquerda"
  }, "\u226A"))), /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    mdUp: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "row",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverTodosParaDireita,
    disabled: left.length === 0,
    "aria-label": "Mover tudo para baixo"
  }, "\u21A1"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverSelecionadosParaDireita,
    disabled: checkedLeft === 0,
    "aria-label": "Mover selecionados para baixo"
  }, "\u2193"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverSelecionadosParaEsquerda,
    disabled: checkedRight === 0,
    "aria-label": "Mover selecionados para cima"
  }, "\u2191"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: moverTodosParaEsquerda,
    disabled: right.length === 0,
    "aria-label": "Mover tudo para cima"
  }, "\u219F")))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: true,
    className: classes.rootPaperRight
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend",
    className: classes.label
  }, labelRight), renderizarLista(dadosItensDireita, "Nenhum item adicionado")));
};
SttDoubleList.propTypes = {
  selectedItens: _propTypes["default"].arrayOf(_propTypes["default"].object),
  allItens: _propTypes["default"].arrayOf(_propTypes["default"].object),
  getItemIdentifier: _propTypes["default"].func.isRequired,
  getItemText: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func,
  callbackReset: _propTypes["default"].func,
  reset: _propTypes["default"].bool,
  labelLeft: _propTypes["default"].string,
  labelRight: _propTypes["default"].string
};
SttDoubleList.defaultProps = {
  selectedItens: [],
  allItens: [],
  reset: false
};
var _default = SttDoubleList;
exports["default"] = _default;